module.exports = require('./helpers/bundle-url').getBundleURL('17nMI') + "blog-2.c684164b.jpeg" + "?" + Date.now();